import type { EntryKey } from "@pinia/colada";
import type { ShallowRef } from "vue";

import { useQueryCache } from "@pinia/colada";
import { watch } from "vue";

function useQueryNormalize<Data>(
  data: ShallowRef<Data[] | undefined>,
  key: (data: Data) => EntryKey,
) {
  const queryCache = useQueryCache();

  watch(
    data,
    (items) => {
      items?.forEach((item) => {
        queryCache.setQueryData(key(item), item);
      });
    },
    { immediate: true },
  );
}

export { useQueryNormalize };
